import React, { useState, useCallback } from "react";
import "./style.scss";
import CopyIcon from "../../../assets/icons/copy-blue.svg";
import ArrowLeft from "../../../assets/icons/dropdown-arrow-gray.svg";
import plus from "../../../assets/icons/AddIcon.svg";
import minus from "../../../assets/icons/minus.svg";
import copy from "../../../assets/icons/copy-white.svg";
import IncrementDecrementInput from "./IncrementDecrementInput";
import { UserSearchReq, baseUrl } from "../../../utils/api/apis";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createAffiliateData } from "../../../store/reducers/affiliateSlice";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import { returnErrors } from "../../../store/reducers/error";
import { returnMessages } from "../../../store/reducers/message";
import debounce from "lodash/debounce";

const CreateCodes = () => {
  const [emailOpts, setEmailOpts] = useState([{ label: "", value: "" }]);
  const [isLoading, setIsLoading] = useState(false);
  const [codeLink, setCodeLink] = useState("");
  const [couponData, setCouponData] = useState({
    email: "",
    code: "",
    percentage: 0,
    customer_discount: 60,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const idToken = useSelector((state) => state.auth.idToken);

  const routeOptions = [
    { value: "/affiliate-marketing/affiliate-list", label: "Affiliate List" },
    { value: "/affiliate-marketing/codes-list", label: "Codes List" },
    {
      value: "/affiliate-marketing/create-codes",
      label: "Create Affiliate Code",
    },
  ];

  const currentRoute =
    routeOptions.find((option) => option.value === location.pathname) ||
    routeOptions[0];

  const handleRouteChange = (selectedOption) => {
    navigate(selectedOption.value);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      background: "none",
      width: "100%",
      height: 60,
      borderRadius: 8,
      border: "1px solid #eaf0f8",
      boxShadow: "none",
      fontFamily: "DM Sans, sans-serif",
      fontSize: "14px",
      fontWeight: 700,
      minHeight: "48px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "grey",
      fontSize: "14px",
      fontWeight: 500,
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "48px",
      padding: "0 6px",
      fontWeight: 500,
      marginLeft: "10px",
      color: "#000",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      color: "#000",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    DropdownIndicator: () => ({
      display: "none",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "48px",
    }),
  };

  const debouncedSearch = useCallback(
    debounce(async (value) => {
      if (!value || value.length < 2) return;

      setIsLoading(true);
      try {
        const response = await UserSearchReq(idToken, value);
        if (response?.status < 399) {
          const userArray = response.data.map((item) => ({
            label: item?.email,
            value: item?.email,
          }));
          setEmailOpts(userArray);
        } else {
          const msg =
            response?.response?.data?.detail ||
            response?.response?.data?.message ||
            "Something went wrong";
          dispatch(returnErrors(msg, 400));
        }
      } catch (error) {
        dispatch(returnErrors("Failed to search users", 400));
      } finally {
        setIsLoading(false);
      }
    }, 500),
    [idToken, dispatch]
  );

  // --- Updated Increment/Decrement Logic ---
  const handleIncrease = () => {
    const { percentage, customer_discount } = couponData;
    if (percentage < 60) {
      setCouponData({
        ...couponData,
        percentage: percentage + 1,
        customer_discount: Math.max(0, customer_discount - 1),
      });
    }
  };

  const handleDecrease = () => {
    if (couponData.percentage > 0) {
      setCouponData({
        ...couponData,
        percentage: couponData.percentage - 1,
        customer_discount: Math.min(
          60 - (couponData.percentage - 1),
          couponData.customer_discount + 1
        ),
      });
    }
  };

  const handleIncreaseRepeat = () => {
    const { percentage, customer_discount } = couponData;
    if (customer_discount < 60) {
      setCouponData({
        ...couponData,
        customer_discount: customer_discount + 1,
        percentage: Math.max(0, percentage - 1),
      });
    }
  };

  const handleDecreaseRepeat = () => {
    if (couponData.customer_discount > 0) {
      setCouponData({
        ...couponData,
        customer_discount: couponData.customer_discount - 1,
        percentage: Math.min(
          60 - (couponData.customer_discount - 1),
          couponData.percentage + 1
        ),
      });
    }
  };

  const handleSubmit = async () => {
    const { code, email } = couponData;
    if (!code || !email) {
      dispatch(returnErrors("Please enter a Coupon Code and Email.", 400));
      return;
    }

    try {
      const config = {
        headers: { Authorization: `Bearer ${idToken}` },
      };
      const res = await axios.post(
        `${baseUrl}affiliates/admin/v2/create-link/`,
        couponData,
        config
      );
      if (res.data.code !== couponData.code) {
        dispatch(returnErrors("Please enter a unique value", 400));
      } else {
        setCodeLink(res.data.url);
        dispatch(returnMessages("Successfully created coupon Code", 200));
      }
    } catch (error) {
      dispatch(
        returnErrors(
          error.response?.data?.detail || "Failed to create coupon",
          400
        )
      );
    }
  };

  const handleCopyToClipboard = (text) => {
    if (text !== "") {
      toast(text ? "Text copied to clipboard !" : "NA", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
        theme: "dark",
        className: "custom-toast-container",
      });
    }
  };

  return (
    <div className="affiliate_codes create_aff_code">
      <div className="mobileNavSelector" style={{ marginBottom: "20px" }}>
        <Select
          options={routeOptions}
          value={currentRoute}
          onChange={handleRouteChange}
          isSearchable={false}
        />
      </div>

      <div className="affiliate_table2">
        <div className="get_a_link_header">
          <h4>
            Create Your Affiliate Code -- {codeLink ? couponData.code : ""}
          </h4>
        </div>

        <div className="get_a_link_conatiner2">
          <div className="coupon_code">
            <div className="common_container">
              <h4>Your Unique Coupon Code</h4>
              <div className="input_div coupon_code_">
                <input
                  type="text"
                  placeholder="Coupon Code"
                  className="input_container"
                  style={{ textTransform: "uppercase" }}
                  value={couponData.code}
                  onChange={(e) => {
                    const value = e.target.value
                      .toUpperCase()
                      .replace(/\s/g, "") // Remove spaces
                      .replace(/[^A-Z0-9]/g, ""); // Allow only alphanumeric characters
                    if (value.length > 15) return; // Limit to 15 characters
                    setCouponData({ ...couponData, code: value });
                  }}
                />
                <ToastContainer />
                <CopyToClipboard
                  text={couponData.code}
                  onCopy={handleCopyToClipboard}
                >
                  <img src={copy} alt="copy-code" />
                </CopyToClipboard>
              </div>
            </div>

            <div className="common_container">
              <h4>Affiliate Email</h4>
              <div className="input_div">
                <Select
                  isLoading={isLoading}
                  placeholder="Search for a user"
                  styles={customStyles}
                  options={emailOpts}
                  onInputChange={(value) => {
                    if (typeof value === "string") debouncedSearch(value);
                  }}
                  onChange={(option) => {
                    setCouponData({ ...couponData, email: option.value });
                  }}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
            </div>

            <div className="common_container">
              <h4>Your Affiliate link</h4>
              <div className="input_div">
                <input
                  type="text"
                  className="copy_text"
                  value={codeLink}
                  readOnly
                />
                <CopyToClipboard text={codeLink} onCopy={handleCopyToClipboard}>
                  <img src={copy} alt="copylink" className="copylink" />
                </CopyToClipboard>
              </div>
            </div>

            <div className="common_container">
              {/* <h4>NOTE: Fixed Commission Income rate for Company is 30%</h4> */}
            </div>
          </div>

          <div className="comission_rate">
            <h4>Your Commission rate</h4>
            <h5>Percentage</h5>
             <div className="rate">
              <div className="icons" onClick={handleDecrease}>
                <img src={minus} alt="decrease" />
              </div>
              <input
                type="number"
                min="0"
                max="60"
                value={couponData.percentage}
                onChange={(e) => {
                  let value = parseInt(e.target.value) || 0;
                  value = Math.max(0, Math.min(value, 60));
                  const remaining = 60 - value;
                  setCouponData({
                    ...couponData,
                    percentage: value,
                    customer_discount: Math.min(
                      couponData.customer_discount,
                      remaining
                    ),
                  });
                }}
              />
              <div className="icons" onClick={handleIncrease}>
                <img src={plus} alt="increase" />
              </div>
            </div>
            <h5>Customer Discount</h5>
            <div className="rate">
              <div className="icons" onClick={handleDecreaseRepeat}>
                <img src={minus} alt="decrease-discount" />
              </div>
              <input
                type="number"
                min="0"
                max="60"
                value={couponData.customer_discount}
                onChange={(e) => {
                  let value = parseInt(e.target.value) || 0;
                  value = Math.max(0, Math.min(value, 60));
                  const remaining = 60 - value;
                  setCouponData({
                    ...couponData,
                    customer_discount: value,
                    percentage: Math.min(couponData.percentage, remaining),
                  });
                }}
              />
              <div className="icons" onClick={handleIncreaseRepeat}>
                <img src={plus} alt="increase-discount" />
              </div>
            </div>
            <div>
              <button className="genrate_button" onClick={handleSubmit}>
                Generate
              </button>
            </div>
            <div>
              {/* <p>NOTE: Fixed Commission Income rates for company is 30%</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CreateCodes;
